import { BlocksIconMachineTractor } from 'blocks-nextjs/blocks-web-components/components/icon/icons/machine-tractor';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMachineTractor = createComponent({ react: React, tagName: 'cat-icon-machine-tractor', elementClass: BlocksIconMachineTractor });
